'use strict';

const Backbone = require('backbone');

const DataPermission = Backbone.Model.extend({
    defaults: {
        permit: false
    },
    isPermitted: function(context) {
        if(context.getGroupRole().isAdmin()) {
            return true;
        }

        return this.get('permit');
    }
}, {
    type: null
});

const DataContentCreatePermission = DataPermission.extend({
}, {
    type: 'data:content:create'
});

const DataContentViewPermission = DataPermission.extend({
}, {
    type: 'data:content:view'
});

const DataContentAddVersionPermission = DataPermission.extend({
    defaults: {
        permit_when: 'none'
    },
    isPermitted: function(context) {
        if (context.getGroupRole().isAdmin()) {
            return true;
        }

        // 所有者が自分のDataContentは編集できる
        const owner_user_id = context.getDataContent().getOwner();
        if (owner_user_id == context.getUser().id) {
            return true;
        }

        const permitWhen = this.get('permit_when');
        if (permitWhen == 'always') {
            return true;
        }

        if (permitWhen == 'related') {
            // TODO: 担当者になっているアクションに関連づいていれば、 True を返すように治す
            return true;
        }

        return false;
    }
}, {
    type: 'data:content:add-version'
});

const DataContentDeletePermission = DataPermission.extend({
    defaults: {
        permit_when: 'none'
    },
    isPermitted: function(context) {
        if (context.getGroupRole().isAdmin()) {
            return true;
        }

        // 所有者が自分のDataContentは削除できる
        const owner_user_id = context.getDataContent().getOwner();
        if (owner_user_id == context.getUser().id) {
            return true;
        }

        const permitWhen = this.get('permit_when');
        if (permitWhen == 'always') {
            return true;
        }

        return false;
    }
}, {
    type: 'data:content:delete'
});

module.exports = {
    DataPermissions: [
        DataContentCreatePermission,
        DataContentViewPermission,
        DataContentAddVersionPermission,
        DataContentDeletePermission,
    ],
    DataContentCreatePermission: DataContentCreatePermission,
    DataContentViewPermission: DataContentViewPermission,
    DataContentAddVersionPermission: DataContentAddVersionPermission,
    DataContentDeletePermission: DataContentDeletePermission,
};



// WEBPACK FOOTER //
// ./data/domain/entity/permission.js